import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import {Link,browserHistory} from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import $ from 'jquery';

const responseGoogle = (response) => {
   console.log(response);
}
// const responseFacebook = (response) => {
//   console.log(response);
// }

class Web_Registration extends Component{
  
  constructor(props){
    super(props);
    this.state={
      status: '',
      msg: '',
    };
    this.handleFormSubmit=this.handleFormSubmit.bind(this);
    this.getFbData=this.getFbData.bind(this);
    this.getGoogleData=this.getGoogleData.bind(this);
  }

  componentWillReceiveProps(newProps) 
  {
     if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") 
     {
        localStorage.setItem('pwd',newProps.formdata.pwd);
        localStorage.setItem('mobile_number',newProps.formdata.mobile);
        browserHistory.push('/web/Otpverify');
        window.location.reload();
      }
      if (newProps.formdata.status === 'success' && newProps.formdata.page === "login") 
      {
        browserHistory.push('/web/account');
        window.location.reload();
      }
      if (newProps.formdata.status === 'success' && newProps.formdata.page === "signup") 
      {
        browserHistory.push('/web/signup'); 
        window.location.reload();
      }      
  }
  componentDidMount()
  {
    $(window).scrollTop(10);
    if(screen.width > 800 && localStorage.token && localStorage.user_id)
    {
      window.location.href="/web/home";
    }
  }
  handleFormSubmit(formProps)
  {
    //this.props.OTPsent(formProps);
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    var data1={from:'desktop_web',mobile: formProps.mobile,device_id: localStorage.getItem('push_device_id')}; 
    var data2 = JSON.stringify(data1);
    var flag=0;
    const mobile_Pattern = /^([0-9]){10}$/;
    if(!mobile_Pattern.test(formProps.mobile))
    {
      $('#num_err').text('Enter valid mobile number');
      flag=1;  
    }
    if(flag === 0)
    {
      var button = $('#reg_btn');
      button.html("loading...");
      button.prop("disabled",true);  
      $.ajax({
              method: 'POST',
              url:baseUrl+'sentOtp',
              dataType:'json',
              data: {req:data2},
              success: function(data){
                  button.html("proceed");
                  button.prop("disabled",false);
                  localStorage.setItem('mobile_number',data.mobile);
              if (data.status === 'success' && data.page === "login") {
                  browserHistory.push('/web/account');
              }else
              if (data.status === 'success' && data.page === "signup") {
                  browserHistory.push('/web/signup'); 
              }else
              if (data.status === 'success' && data.page === "otp")
              {
                  localStorage.setItem('pwd',data.pwd);
                  localStorage.setItem('mobile_number',data.mobile);
                  browserHistory.push('/web/Otpverify');
                  window.location.reload();      
              }
          },
          error: function(err)
          { 
            // console.log("Error"+err);
          }
      });
    }
  }
  getFbData(res)
  {
      console.log(res);

      this.setState({
          name: res.name,
          email: res.email,
          id: res.id,
          userId: res.user_id,
          expiresIn: res.expiresIn,
          picture: res.picture.data.url,
      });

      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1={from:'desktop_web',name: res.name,social_type: '1',email:res.email,device_id:localStorage.getItem('push_device_id'),version:'',platform:'',language:''};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'post',
          data: {req: data2},
          url: baseUrl+'social_login',
          success: function(data){
            data= JSON.parse(data);
            if(data.status==='success' && data.page_source==='dashboard')
            {
              localStorage.setItem('token',data.token);
              localStorage.setItem('f_uid',data.uid);
              localStorage.setItem('user_id',data.uid);
              browserHistory.push('/web/home');
            }
            else if(data.status ==='success' && data.page_source==='mobile_number')
            {
              localStorage.setItem('f_uid',data.uid);
              localStorage.setItem('user_id',data.uid);
              localStorage.setItem('f_email',data.email);
              browserHistory.push('/web/mobile');
            }
            else if(data.status === 'success' && data.page_source==="otp_screen")
            {
              localStorage.setItem('mobile_number',data.mobile);
              browserHistory.push('/web/mobile/verify_otp');
              window.location.reload();
            }
          },
          error: function(err)
          {
            // console.log(err);
          }
      });
  }
  getGoogleData(res)
  {
      console.log(res);
      console.log(JSON.stringify(res));
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1={from:'desktop_web',name: res.profileObj.name,social_type: '2',email:res.profileObj.email,device_id:localStorage.getItem('push_device_id')};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'post',
          dataType:'json',
          data:{req: data2},
          url: baseUrl+'social_login',
          success: function(data)
          {
              // data= JSON.parse(data);
              if(data.status==='success' && data.page_source==='dashboard')
              {
                localStorage.setItem('token',data.token);
                localStorage.setItem('f_uid',data.uid);
                localStorage.setItem('user_id',data.uid);
                browserHistory.push('/web/home');
                window.location.reload();
              }
              else if(data.status ==='success' && data.page_source==='mobile_number')
              {
                localStorage.setItem('f_uid',data.uid);
                localStorage.setItem('user_id',data.uid);
                localStorage.setItem('f_email',data.email);
                browserHistory.push('/web/mobile');
                window.location.reload();
              }
              else if(data.status === 'success' && data.page_source==="otp_screen")
              {
                localStorage.setItem('mobile_number',data.mobile);
                browserHistory.push('/web/mobile/verify_otp');
                window.location.reload();
              }
           },
          error: function(err)
          {
             // console.log(err);
          }
      });
  }

  render(){
        $('#num_input').keyup(function(){
          $('#num_err').text('');
        });
      localStorage.removeItem('h_type');
      $(window).scrollTop(10);
      document.title ="AquaDeals Registration - You find,buy best deals by register with us";
      document.getElementsByTagName("META")[2].content="You find,buy best deals by register with us";
      const {handleSubmit,fields:{mobile}} = this.props;
          return (
    
<div className="lgt_gry web_deals web_reg_page">
<WebHeaderInner />
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<section className="container dels_cntnt">
  <div className="row">
  <div className="col-md-12 del_rgt">
    <div className="del_rgt_blk">
    <div className="del_dtl">
<div className="">
<div className="col-md-6 col-md-offset-3">
  {/*   <!-- login form start --> */}
    <div className="">
    <div className="newlogin_logo"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
    <div className="enquire_form signup_blk proced_blk" style={{marginLeft:'40px',marginRight:'40px'}}>
      <div className="clr">&nbsp;</div>
        <form className="mtrl_elmnts login_blk" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          <div className="col-md-12">
            <div className="col-md-10 col-md-offset-1">
              <div className="group">      
                  <img src={'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'9px',left:'0px'}} />
                  <input type="text" {...mobile} id="num_input" placeholder="Enter Mobile" required maxLength={10} />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <span style={{color: 'red'}} id="num_err" ></span>
              </div>
              <button action="submit" className="btn web_reg_btn" id="reg_btn">PROCEED <i className="glyphicon glyphicon-menu-right"></i></button>
            </div>
          </div>
      </form>
      {/*<div className="clr">&nbsp;</div>*/}
      <div className="clr">&nbsp;</div>
      <div className="clr">&nbsp;</div>
    </div>
  </div>
  {/*<div className="col-md-10 col-md-offset-1">
      <h4 style={{marginTop: '10px',marginBottom: '20px',color: '#777',textAlign: 'center',fontSize: '13px'}}>---- or sign in with ----</h4>
      <div className="clr">&nbsp;</div>
        <div className="col-md-4" style={{textAlign:'center'}}>
            <Link to="/web/ab_login"><button type="button" className="ab-lgn-btn"><span><img src={'https://aquadeals.in/admin/assets/icons/web_icons/ab-lgn.png'} alt="" width="50px" /></span></button></Link>
        </div>
        <div className="col-md-4">
          <FacebookLogin
              appId="1677330529233582"
              textButton={<FbLogo />}
              autoLoad={false}
              fields="name,email,picture"
              callback={this.getFbData}
              cssClass="fb_lgn_btn"
            >
          </FacebookLogin>
        </div>
      <div className="col-md-4" style={{textAlign:'center'}}>
          <GoogleLogin className="google-lgn-btn" 
              clientId={'252840862313-6chaofdjgcq8b9e08gbmevj9pjo9atqe.apps.googleusercontent.com'}
              onSuccess={this.getGoogleData}
              onFailure={responseGoogle}
              autoLoad={false}
            >
            <span><img src="https://aquadeals.in/admin/assets/icons/web_icons/g-lgn.png" alt=" " width="50px" /></span>
          </GoogleLogin>
      </div>
      
    </div>*/}
    </div>
    </div>
{/*  <div className="clr">&nbsp;</div>
  <div className="clr">&nbsp;</div>*/}
  </div>
  </div>
  </div>
</div>
{/*<div className="clr">&nbsp;</div> 
<div className="clr">&nbsp;</div>*/}
</section>
<WebFooter />
</div>   
    );
  }
}

function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata
  };
}

export default reduxForm({
  form :'register',
  fields:['mobile'],
},mapStateToProps,actions)(Web_Registration);


class FbLogo extends Component{
  render(){
    return(
        <img src={"https://aquadeals.in/admin/assets/icons/web_icons/fb-lgn.png"} width="50px" alt=" " />
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Auth/Web_Registration.js
 **/